// extracted by mini-css-extract-plugin
export default {"auth":"AuthForm_auth__i9OWK","control":"AuthForm_control__v9c8q","actions":"AuthForm_actions__olb9Z","toggle":"AuthForm_toggle__EpPDR"};